<template>
  <div ref="observerRoot">
    <slot v-bind="observerProps" />
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { computed } from 'vue';

export default {
  name: 'ValidationObserver',
  setup() {
    // Create a form-level validation context
    const v$ = useVuelidate();

    const validate = async () => await v$.value.$validate();
    const reset = () => v$.value.$reset();

    const transformErrorsToObject = (errors) => {
      const errorsObj = {};
      if (Array.isArray(errors)) {
        errors.forEach((error) => {
          const fieldName = error.$property;
          if (fieldName) {
            errorsObj[fieldName] = error.$message;
          }
        });
      }
      return errorsObj;
    };

    const observerProps = computed(() => {
      const errors = transformErrorsToObject(v$.value.$errors);

      return {
        // Vuelidate native
        v$: v$.value,

        // Common props
        errors,
        validate,
        reset,
        invalid: v$.value.$invalid,
        flags: {
          invalid: v$.value.$invalid,
          valid: !v$.value.$invalid,
          dirty: v$.value.$dirty,
          touched: v$.value.$dirty,
          pending: v$.value.$pending,
          changed: v$.value.$dirty // Alias for backward compatibility
        }
      };
    });

    const flags = computed(() => observerProps.value.flags);

    return {
      observerProps,
      validate,
      reset,
      flags
    };
  }
};
</script>
